import { Container } from "./styles";

export const Sobre = () => {
  return (
    <Container>
      <div id="link">
        <h2 className="title-sobre2">Vantagens de ter um bot de atendimento</h2>
        <div className="sobre-banner">
          <img src="capaw2.png" alt="" className="sobre-img" />
          <p>
            <strong>Disponibilidade </strong> uma das principais vantagens do
            chatbot é que ele está disponível 24 horas por dia em todos os dias
            da semana. Assim, é possível atender seus clientes de forma mais
            completa e por mais tempo, mesmo em momentos em que não haja
            atendimento humano.
            <br></br>
            <br></br>
            <strong>Múltiplos atendimentos simultâneos </strong> um chatbot para
            atendimento é capaz de dialogar com qualquer número de pessoas
            simultaneamente. Dessa forma, você não deixa clientes esperando e
            proporciona uma melhor experiência aos usuários.
            <br></br>
            <br></br>
            <strong>Economia de recursos </strong>
            outra possibilidade trazida pelo uso dos chatbots no atendimento ao
            cliente é a economia de recursos. Utilizando os softwares, é
            possível reduzir consideravelmente os custos com funcionários
            voltados para esse tipo de tarefa.
            <br></br>
            <br></br>
          </p>
        </div>
        <p className="p-2">
          <strong> Otimização do tempo </strong>
          Um dos principais pontos positivos no uso de chatbots para atendimento
          é, sem dúvidas, a otimização do tempo do tempo com o cliente. Enquanto
          as empresas que realizam um atendimento via funcionários se deparam em
          vários momentos com o congestionamento de seus canais, aquelas que
          optam pelo uso de chatbots podem atender um número praticamente
          ilimitado de pessoas.
        </p>
      </div>
    </Container>
  );
};
